var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmojisad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4442_1149)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00008 2.00033C4.68637 2.00033 2.00008 4.68662 2.00008 8.00033C2.00008 11.314 4.68637 14.0003 8.00008 14.0003C11.3138 14.0003 14.0001 11.314 14.0001 8.00033C14.0001 4.68662 11.3138 2.00033 8.00008 2.00033ZM0.666748 8.00033C0.666748 3.95024 3.94999 0.666992 8.00008 0.666992C12.0502 0.666992 15.3334 3.95024 15.3334 8.00033C15.3334 12.0504 12.0502 15.3337 8.00008 15.3337C3.94999 15.3337 0.666748 12.0504 0.666748 8.00033Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99998 10.0003C6.66358 10.0003 6.04394 10.7365 5.9296 10.9651C5.76494 11.2945 5.36449 11.4279 5.03517 11.2633C4.70586 11.0986 4.57237 10.6982 4.73703 10.3688C5.06714 9.70863 6.13639 8.66699 7.99998 8.66699C9.86358 8.66699 10.9328 9.70863 11.2629 10.3688C11.4276 10.6982 11.2941 11.0986 10.9648 11.2633C10.6355 11.4279 10.235 11.2945 10.0704 10.9651C9.95603 10.7365 9.33639 10.0003 7.99998 10.0003Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33325 6.00065C5.33325 5.63246 5.63173 5.33398 5.99992 5.33398H6.00659C6.37478 5.33398 6.67325 5.63246 6.67325 6.00065C6.67325 6.36884 6.37478 6.66732 6.00659 6.66732H5.99992C5.63173 6.66732 5.33325 6.36884 5.33325 6.00065Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33325 6.00065C9.33325 5.63246 9.63173 5.33398 9.99992 5.33398H10.0066C10.3748 5.33398 10.6733 5.63246 10.6733 6.00065C10.6733 6.36884 10.3748 6.66732 10.0066 6.66732H9.99992C9.63173 6.66732 9.33325 6.36884 9.33325 6.00065Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4442_1149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.000488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojisad);
export default __webpack_public_path__ + "static/media/emojisad.bb1462fdb58157d2ee25c0360c69e2e1.svg";
export { ForwardRef as ReactComponent };